<template>
  <el-dialog
    :title="type == 'ready'?'上传协议(已盖章)':'上传协议(终)和证书'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="675px"
    :before-close="handleClose">
    <div class="font12" v-if="type == 'ready'">
      <div class="flex-box">
        <div class="title"><span style="color:red">*</span>上传协议(已盖章)</div>
        <div>
          <vat-up-load :fileUrl.sync="img1" :accept="'.pdf'"  @updataUrl="upimg1"></vat-up-load>
        </div>
      </div>
      <div class="tip">
        <p>1、请先下载协议（原件）后，签字盖章后，扫描上传</p>
        <p>2、支持pdf格式上传，最大不超过50M</p>
      </div>
    </div>
    <div class="font12" v-else>
      <div class="flex-box">
        <div class="title"><span style="color:red">*</span>上传协议(终)</div>
        <div>
          <vat-up-load :fileUrl.sync="img1" :accept="'.pdf'"  @updataUrl="upimg1"></vat-up-load>
        </div>
      </div>
      <div class="tip">
        <p>1、请上传带有客户签名盖章、代理签名盖章的协议，上传后，在客户端能下载该协议</p>
        <p>2、支持pdf格式上传，最大不超过50M</p>
      </div>
      <div class="flex-box" v-if="code == 'EU'">
        <div class="title"><span style="color:red">*</span>上传证书</div>
        <div>
          <vat-up-load :fileUrl.sync="img2" :accept="'.pdf,image/jpeg,image/png'"  @updataUrl="upimg"></vat-up-load>
        </div>
      </div>
      <div class="tip" v-if="code == 'EU'">
        <p>1、请上传代理返回的证书，上传后，在客户端能下载该协议</p>
        <p>2、支持pdf、png等格式上传，最大不超过50M</p>
      </div>
      <div class="flex-box">
        <div class="title"><span style="color:red">*</span>协议起止时间</div>
        <div>
          <el-date-picker
            size="small"
            v-model="xdate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
    </div>
    <el-row slot="footer" class="dialog-footer marTop20" style="text-align: center">
      <el-button class="width100" size="small" type="primary" @click="submit">确定</el-button>
      <el-button class="width100" size="small" @click="dialogVisible = false;visibleStart = false">关 闭</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import upLoad from '@/components/upload/index'
import vatUpLoad from '@/components/vatupload/index'
import AreaCode from '@/components/AreaCode';
import showImg from '@/components/upload/showImg.vue'
export default {
  name: 'addBuy',
  components:{
    upLoad,
    AreaCode,
    showImg,
    vatUpLoad
  },
  data () {
    return {
      radio:false,
      title:'上传协议(终)和证书',
      dialogVisible:false,
      registerVisible:false,
      dataInfo:{},
      radio:true,
      labelPosition:'top',
      img1:'',
      img2:'',
      xdate:'',
      id:'',
      code:'',
      type:'',
    }
  },
  methods: {
    upimg1(val){
          this.img1 = val
      },
    upimg(val){
          this.img2 = val
      },
      //查看大图
    show(oid,code,type){
      this.img1 = this.img2 = ''
      this.code = code
      this.type = type
      this.id = oid
      this.dialogVisible = true
    },
    submit(){
      if(this.type == 'ready'){
        this.proofSubmit()
      }else{
        this.handleSubmit()
      }
    },
    proofSubmit(){
      if(this.img1 == '') return this.$message.warning('协议不能为空')
      let params = {
        orderId:this.id,
        agreement:this.img1,
      }
      this.ajax.put(`/EURepOrder/upload/agreement/signed`,params,'vatService').then(res=>{
          if(res){
            this.$message({type:'success',message:'操作成功'})
            this.dialogVisible = false;
            this.$emit('fetch')
          }
      })
    },
    handleSubmit(){
      if(this.img1 == '') return this.$message.warning('协议不能为空')
      if(this.code == 'EU'){
        if(this.img2 == '') return this.$message.warning('证书不能为空')
      }
      if(this.xdate == '') return this.$message.warning('协议起止日期不能为空')
        let params = {
          orderId:this.id,
          agreement:this.img1,
          proof:this.img2,
          begin:this.xdate[0],
          end:this.xdate[1]
        }
        this.ajax.put(`/EURepOrder/upload/agreement`,params,'vatService').then(res=>{
            if(res){
              this.$message({type:'success',message:'操作成功'})
              this.dialogVisible = false;
              this.$emit('fetch')
            }
        })
    },
    handleClose(done) {
      done();
    },
  }
}
</script>

<style scoped>
.margBottom15{
  margin-bottom: 15px;
}
/deep/.el-form-item--small .el-form-item__label{
  padding: 0!important;
}
.flex-box{
  width: 100%;
}
.marLF10{
  margin-left: 10px;
}
.font12{
  font-size: 12px;
}
.inline-box{
  width: 49%;
  display: inline-block;
  font-size: 12px;
  position: relative;
}
.btip{
  position: absolute;
  bottom: 8px;
  left: 0;
}
.tip{
  color: #999;
  font-size: 12px;
}
.orderInfo-item {
        display: inline-flex;
        margin-top: 20px;
        width: 33%;
        padding-right: 40px;
  }
  .width60 {
    display: inline-block;
    width: 80px;
  }
  .marRight80{
    margin-right: 15px;
  }
  .margBottom20{
    margin-bottom: 20px;
  }
  /* 1440屏以下，去掉侧边栏的宽度 */
    @media screen and (max-width: 1421px) {
        .orderInfo-item {
            width: 33%;
        }
        .marRight80 {
            margin-right: 15px !important;
        }
    }

    /deep/ .el-input.is-disabled .el-input__inner {
        cursor: revert;
    }
    @media only screen and (max-width: 1280px) {
        .orderInfo-item{
            margin-top: 15px;
        }
        .marRight80 {
            margin-right: 30px !important;
        }
        .right-icon > svg {
            font-size: 62px !important;
        }
    }
    .w-space{
      white-space: nowrap;
    }
    .flex-box{
      display: flex;
      align-items: center;
      margin-top: 20px;
    }
    .flex-box>.title{
      margin-right: 20px;
    }
    .tip{
      margin-top: 15px;
      margin-left: 74px;
    }
</style>


// WEBPACK FOOTER //
// src/components/compliance/component/upxbook.vue